import { useEffect, useState } from "react";
import apiClient from "../../api/client";
import { toast } from "react-toastify";
import PackDetails from "../PackDetails";

// Plan-length filter for OTT plans (duration is stored in days).
// Ranges rather than exact numbers so 28/30/31-day plans are all "Monthly".
const DURATION_FILTERS = [
  { key: "monthly", label: "Monthly", test: (d) => d > 0 && d <= 45 },
  { key: "quarterly", label: "Quarterly", test: (d) => d > 45 && d <= 135 },
  { key: "halfyearly", label: "Half-yearly", test: (d) => d > 135 && d <= 270 },
  { key: "annual", label: "Annually", test: (d) => d > 270 },
];
const TYPES_WITH_DURATION_FILTER = ["watcho", "etvwin"];

const ChangePlanModal = ({ visible, onClose, userId, type, currentPlanId, slot, onSuccess,
  allowedPlans,
  fetchComboOptions }) => {

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [durationFilter, setDurationFilter] = useState("all");

  useEffect(() => {
    if (!visible) return;
    setDurationFilter("all");

    const fetchPlans = async () => {
      setLoading(true);
      try {
        const { data } = await apiClient.get(`/customer/get_operator_plans.php?category=${type}`);
        setPlans(data.plans || []);
      } catch (error) {
        console.error("Error fetching plans:", error);
        toast.error("Failed to load plans");
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [visible, type]);

  const handleSelect = async (plan) => {
    if (type === "ottplay" && slot === "1") {
      // fetchComboOptions({ ott1: plan.id });
    }

    if (type === "ottplay" && slot === "2") {
      // fetchComboOptions({ ott2: plan.id });
    }

    if (type === "watcho") {
      fetchComboOptions({ watcho: plan.id });
    }

    if (type === "playboxtv") {
      fetchComboOptions({ playboxtv: plan.id });
    }

    if (type === "antiptv" && slot === "1") {
      fetchComboOptions({ antiptv: plan.id });
    }


    if (!window.confirm("Change plan?")) return;

    setSubmitting(true);
    try {
      const { data } = await apiClient.post(
        "/customer/change_plan.php",
        {
          user_id: userId,
          plan_id: plan.id,
          type,
          slot: slot
        }
      );

      if (data.success) {
        toast.success("Plan updated");
        onSuccess();
        onClose();
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      console.error("Error changing plan:", error);
      toast.error("Failed to change plan");
    } finally {
      setSubmitting(false);
    }
  };

  if (!visible) return null;

  const allowedForCustomer = plans.filter(plan => {

    if (type === "ottplay" && slot === "2") {
      return !allowedPlans?.ottplay2?.length ||
        allowedPlans.ottplay2.includes(plan.id);
    }

    if (type === "watcho") {
      return !allowedPlans?.watcho?.length ||
        allowedPlans.watcho.includes(plan.id);
    }

    if (type === "ottplay" && slot === "1") {
      return !allowedPlans?.ottplay1?.length ||
        allowedPlans.ottplay1.includes(plan.id);
    }

    return true;
  });

  const showDurationFilter = TYPES_WITH_DURATION_FILTER.includes(type);
  const durationCounts = DURATION_FILTERS.map((f) => ({
    ...f,
    count: allowedForCustomer.filter((p) => f.test(Number(p.duration))).length,
  }));
  const activeDuration = DURATION_FILTERS.find((f) => f.key === durationFilter);
  const filteredPlans = showDurationFilter && activeDuration
    ? allowedForCustomer.filter((p) => activeDuration.test(Number(p.duration)))
    : allowedForCustomer;

  return (
    <div className="modal-overlay">
      <div className="modal-content-plan large">
        <div className="modal-header">
          <h3>Select {type.toUpperCase()} Plan</h3>

          <button
            className="btn-close-plan"
            onClick={onClose}
            disabled={submitting}
          >
            ✕
          </button>
        </div>

        {showDurationFilter && !loading && allowedForCustomer.length > 0 && (
          <div className="plan-duration-filter" role="tablist" aria-label="Plan length">
            <button
              type="button"
              className={durationFilter === "all" ? "active" : ""}
              onClick={() => setDurationFilter("all")}
            >
              All <span>{allowedForCustomer.length}</span>
            </button>
            {durationCounts.map((f) => (
              <button
                key={f.key}
                type="button"
                className={durationFilter === f.key ? "active" : ""}
                onClick={() => setDurationFilter(f.key)}
                disabled={f.count === 0}
                title={f.count === 0 ? `No ${f.label.toLowerCase()} plans` : undefined}
              >
                {f.label} <span>{f.count}</span>
              </button>
            ))}
          </div>
        )}

        <div className="modal-body">
          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Loading plans...</p>
            </div>
          ) : (
            <div className="addon-grid">
              {filteredPlans.length === 0 ? (
                <div className="no-plans-message">
                  <p>{plans.length === 0 ? "No plans available" : "No plans for this duration"}</p>
                </div>
              ) : (

                filteredPlans.map(plan => {
                  const isCurrent = Number(plan.id) === Number(currentPlanId);

                  return (
                    <div
                      key={plan.id}
                      className={`plan-card ${isCurrent ? "current-plan" : ""} ${submitting ? "disabled" : ""}`}
                      onClick={() => !isCurrent && !submitting && handleSelect(plan)}
                      style={submitting && !isCurrent ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                    >
                      {isCurrent && <div className="current-badge">CURRENT</div>}
                      <PackDetails {...plan} />
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePlanModal;